/**
 * @file HeaderLoginPagesSlot.tsx
 *
 * @fileoverview This component can be used to render custom things on top of login and register pages.
 */

export const HeaderLoginPagesSlot = () => {
  return null;
};

export default HeaderLoginPagesSlot;
